import { render } from "./ZombieFightModal.vue?vue&type=template&id=7ea95da4&scoped=true"
import script from "./ZombieFightModal.vue?vue&type=script&lang=js"
export * from "./ZombieFightModal.vue?vue&type=script&lang=js"

import "./ZombieFightModal.vue?vue&type=style&index=0&id=7ea95da4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ea95da4"]])

export default __exports__